import { atom } from 'jotai';
import type { ProcessServerConfigFunction } from 'filepond';
import type { EImageVariant } from '@onesource/schemas';
import type { EMimeType } from '../../../file-uploader/file-uploader';

export interface IMediaManagerAtom {
  allowedFormats?: EMimeType[];
  selectVariant?: EImageVariant;
  uploadVariants?: EImageVariant[];
  variantsEditable?: boolean;
  processHandler: ProcessServerConfigFunction;
  onSelect: (key: string, publicUrl: string | null) => void;
  /** UUID of the currently selected file — used to pre-highlight the grid */
  value?: string;
  /** Aspect ratio for the crop tool (width / height). e.g. 1 for square. Defaults to free-form. */
  cropAspectRatio?: number;
  /** Number of file thumbnails to show per row in the uploader panel. Defaults to 1. */
  uploaderColumns?: number;
  /** When true, shows system-wide files instead of personal files. Only usable by admin/kit_organizer. */
  isSystemUpload?: boolean;
}

export const mediaManagerAtom = atom<IMediaManagerAtom | null>(null);
